// Estado intermedio entre "aún no se sabe si hay sesión" y la decisión final
// (ver hooks/useAuth.tsx, status='checking') — evita el flash de la pantalla
// de login mientras se intenta el silent refresh contra /auth/refresh.
export function FullScreenLoader() {
  return (
    <div className="login-screen">
      <div className="login-box" style={{ textAlign: 'center' }}>
        <div className="login-logo" style={{ justifyContent: 'center' }}>
          <div className="login-logo-mark">NX</div>
          <div className="login-logo-text">
            Nexus
            <span>Leadsphere Connect</span>
          </div>
        </div>
        <p className="login-hint">Verificando sesión…</p>
      </div>
    </div>
  );
}
